import { Box, Skeleton, TablePagination } from '@mui/material';
import ProjectTileNew from 'components/ProjectTileNew';
import { useTranslation } from 'react-i18next';

const SKELETON_COUNT = 18;

const ProjectGridSkeleton = () => (
  <Box
    className="item"
    sx={{
      width: 219,
      height: 307,
      borderRadius: '3px',
      overflow: 'hidden',
    }}
  >
    <Skeleton variant="rectangular" width="100%" height={217} sx={{ borderRadius: 0 }} />
    <Box sx={{ p: 1.5 }}>
      <Skeleton variant="text" width="80%" height={26} sx={{ mb: 0.5 }} />
      <Skeleton variant="text" width="60%" height={20} />
    </Box>
  </Box>
);

const ProjectGridView = ({
  data,
  pagination,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  refetchingData,
  deleteProjecthandler,
  loading = false,
}: any) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box className="main__content">
        <Box className="items">
          {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
            <ProjectGridSkeleton key={i} />
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box className='main__content'>
      <Box className='items'>
        {data
          .map((data: any) => {
            return (
              <ProjectTileNew
                data={{ ...data, handleDeleteProject: deleteProjecthandler }}
                key={data.id}
                refetch={refetchingData}
              />
            );
          })}
      </Box>
      <TablePagination
        rowsPerPageOptions={[20]}
        component="div"
        page={page - 1}
        count={pagination.total}
        onPageChange={(_, newPage) => onPageChange(newPage + 1)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={(e) => {
          const newPageSize = parseInt(e.target.value, 20);
          onPageSizeChange(newPageSize);
        }}
        labelDisplayedRows={({ from, to, count }) => t('MUI_PAGINATION_RANGE', { from, to, count })}
        getItemAriaLabel={(type) => t(`MUI_PAGINATION_${type.toUpperCase()}_PAGE`)}
   /*      labelRowsPerPage={t('MUI_ROWS_PER_PAGE')}
        labelDisplayedRows={({ from, to, count }) => 
          t('MUI_PAGINATION_RANGE', { 
            from: from + 1, 
            to: Math.min(to, count), 
            count 
          })} */
      />
    </Box>
  );
};

export default ProjectGridView;
